import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useTranslations } from 'gt-react'
import { ArrowLeft } from 'lucide-react'
import { toast } from 'sonner'
import { LayoutAwareForm } from '@/components/crm/layout-aware-form'
import { Button } from '@/components/ui/button'
import { orpc } from '@/lib/orpcClient'

export const Route = createFileRoute('/crm/contacts/new')({
  component: NewContactPage,
})

function NewContactPage() {
  const t = useTranslations()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const createMutation = useMutation(
    orpc.crm.contacts.create.mutationOptions({
      onSuccess: (result) => {
        toast.success(t('crm.contact.entity'))
        queryClient.invalidateQueries({ queryKey: orpc.crm.contacts.list.key() })
        const created = result as { id: string }
        navigate({ to: '/crm/contacts/$contactId', params: { contactId: created.id } })
      },
      onError: (e) => toast.error(e.message),
    }),
  )

  return (
    <div className="p-6 max-w-3xl mx-auto space-y-4">
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="sm" onClick={() => navigate({ to: '/crm/contacts' })}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          {t('crm.common.cancel')}
        </Button>
        <h1 className="text-2xl font-bold">{t('crm.contact.newContact')}</h1>
      </div>
      <LayoutAwareForm
        entityKey="contact"
        onSubmit={(value) =>
          createMutation.mutate(value as Parameters<typeof createMutation.mutate>[0])
        }
        submitting={createMutation.isPending}
        submitLabel={t('crm.common.create')}
        onCancel={() => navigate({ to: '/crm/contacts' })}
      />
    </div>
  )
}
